import { render, staticRenderFns } from "./replace.vue?vue&type=template&id=3e8a4016&scoped=true&"
import script from "./replace.vue?vue&type=script&lang=js&"
export * from "./replace.vue?vue&type=script&lang=js&"
import style0 from "./replace.vue?vue&type=style&index=0&id=3e8a4016&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8a4016",
  null
  
)

export default component.exports